exports.NumberOfPeople = [{
    id:0,
    description: "0"
  },
  {
    id: 1,
    description: "1 to 10",
  }, {
    id: 2,
    description: "11 to 25",
  }, {
    id: 3,
    description: "26 to 50",
  }, {
    id: 4,
    description: "51 to 100",
  }, {
    id: 5,
    description: "101 to 250",
  }, {
    id: 6,
    description: "Over 250",
  }]

  exports.NumberOfPeopleLarge = [{
      id:0,
      description: "0"
    },
    {
      id: 1,
      description: "1 to 10",
    }, {
      id: 2,
      description: "11 to 25",
    }, {
      id: 3,
      description: "26 to 50",
    }, {
      id: 4,
      description: "51 to 100",
    }, {
      id: 5,
      description: "101 to 250",
    }, {
      id: 6,
      description: "251 to 500",
    }, {
      id: 7,
      description: "500 to 1000",
    }, {
      id: 8,
      description: "Over 1000",
    }]

exports.OrganisationManagementType = [{
    id: 1,
    description: "Board Of Directors",
  }, {
    id: 2,
    description: "Trustees",
  }, {
    id: 3,
    description: "Management Committee",
  }, {
    id: 4,
    description: "Council",
  }, {
    id: 5,
    description: "Other",
  }]

exports.SocialMediaType = [{
    id: 1,
    description: "Facebook",
  }, {
    id: 2,
    description: "Google",
  }, {
    id: 3,
    description: "Instagram",
  }, {
    id: 4,
    description: "Twitter",
  }, {
    id: 5,
    description: "Other",
  }]

exports.SupportedProjects = [{
    id: 1,
    description: "Capital",
  }, {
    id: 2,
    description: "Revenue - core",
  }, {
    id: 3,
    description: "Revenue - non-core",
  }, {
    id: 4,
    description: "Transformational impact",
}]

exports.OrganisationType = [{
    id: 1,
    description: "Charitable Trust",
  }, {
    id: 2,
    description: "Charitable Foundation",
  }, {
    id: 3,
    description: "Registered Charity",
  }, {
    id: 4,
    description: "Company limited by guarantee",
},{
    id: 5,
    description: "Company limited by shares",
  }, {
    id: 6,
    description: "Solicitor",
  }, {
    id: 7,
    description: "Social Housing Provider",
  }, {
    id: 8,
    description: "CIC",
},{
    id: 9,
    description: "CIO",
  }, {
    id: 10,
    description: "Local Authority",
  }, {
    id: 11,
    description: "Social Investment Organisation",
  }, {
    id: 12,
    description: "Livery Company",
}, {
    id: 13,
    description: "Clubs and societies such as Rotary or Round Table or Lions clubs",
  }, {
    id: 14,
    description: "Limited Liability Partnership",
  }, {
    id: 15,
    description: "Other",
}]

exports.YesOrNo = [{
    id: 0,
    description: "No",
  }, {
    id: 1,
    description: "Yes",
  }]

  exports.accountType = [{
    id: 0,
    description: "Building Society Account"
  }, {
    id: 1,
    description: "Bank Account"
  }]

  exports.fundingOfferStatus = [
    {    
      id: 0,
      title: "All"
    },{    
      id: 1,
      title: "Submitted"
    },{    
      id: 2,
      title: "Accepted"
    },{    
      id: 3,
      title: "Confirmed"
    },{    
      id: 4,
      title: "Rejected"
    }
  ]

  exports.fundingOfferType = [{    
    id: -1,
    title: "All"
  },{    
    id: 0,
    title: "Grant"
  },{    
    id: 1,
    title: "Match"
  }]

  exports.projectFundingStatus = [{    
    id: 0,
    title: "All"
  },{    
    id: 1,
    title: "Seeking Funding"
  },{    
    id: 2,
    title: "Funded/Successful"
  }];

  exports.grantMatchProportion = [{
    id:0,
    title: ""},{
    id:1,
    title: "None"},{
    id:2,
    title: "Some"},{
    id:3,
    title: "Maybe"},{
    id:4,
    title: "All" }
  ]
